import { SearchMaskGroupType } from '../../globalTypes';
var parseActiveTabType = function (typeString) {
    var type;
    switch (typeString) {
        case 'last-minute':
            type = SearchMaskGroupType.PACKAGE;
            break;
        case 'hotel':
            type = SearchMaskGroupType.HOTEL;
            break;
        case 'flug':
            type = SearchMaskGroupType.FLIGHT;
            break;
        case 'bahn':
            type = SearchMaskGroupType.RAIL;
            break;
        case 'bahn-und-hotel':
            type = SearchMaskGroupType.RAIL_PACKAGE;
            break;
        default:
            type = SearchMaskGroupType.PACKAGE;
    }
    return type;
};
var CmsResponseMapper = /** @class */ (function () {
    function CmsResponseMapper() {
    }
    CmsResponseMapper.map = function (cmsResponseParam) {
        if (cmsResponseParam === null) {
            return null;
        }
        var cmsResponseResult = cmsResponseParam;
        cmsResponseResult.settings.activeTabNormalized = parseActiveTabType(cmsResponseResult.settings.activeTab);
        return cmsResponseResult;
    };
    return CmsResponseMapper;
}());
export default CmsResponseMapper;
